import { getStorageUserInfo } from 'utils/commonUtil';

export const useUserInfo = () => {
  return getStorageUserInfo();
}